import { render, staticRenderFns } from "./CombinedElementCost.vue?vue&type=template&id=2f03fa14&scoped=true&"
import script from "./CombinedElementCost.vue?vue&type=script&lang=js&"
export * from "./CombinedElementCost.vue?vue&type=script&lang=js&"
import style0 from "./CombinedElementCost.vue?vue&type=style&index=0&id=2f03fa14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f03fa14",
  null
  
)

export default component.exports